import React, { useContext, useEffect } from 'react'
import { ContentContainer, MainContainer } from '../../focus_view_shared.styles'
import { UsersInvitePreviewAndExecutionCard } from '../bulk_users_invite_shared'
import { useTranslation } from 'react-i18next'
import { Invitation } from '../bulk_invite_logic'
import { AlertType } from '@amzn/storm-ui/dist/types/Alert/types'
import * as i18nKeyList from '../bulk_users_invite_i18n_mapping'
import * as AACChromeAPI from '@amzn/aac-chrome-api'
import { getUserManagementURL } from '../../ads_console_utils'
import { toNullable } from 'fp-ts/es6/Option'
import { StageDiveConfig, StageDiveConfigContext } from '../../../../../../util/app_initialization/appconfig'
import { useLoginContext } from 'stagedive/LoginContext'

interface UsersInvitePreviewProps {
  invitations: Invitation[]
  alertType: AlertType
  confirmAction: () => void
}

export const UsersInvitePreview: React.FunctionComponent<UsersInvitePreviewProps> = (props: UsersInvitePreviewProps): JSX.Element => {
  const { t } = useTranslation()
  const { loginContext } = useLoginContext()
  const partnerId = toNullable(loginContext.partnerProfileId) ?? ''
  const stageDiveConfig = useContext<StageDiveConfig>(StageDiveConfigContext)

  useEffect(() => {
    const chromeConfig = AACChromeAPI.getChromeConfiguration()
    const pageHeader = new AACChromeAPI.PageHeader()
    const objectInfo = new AACChromeAPI.ObjectInfo()
    const actionList = new AACChromeAPI.ItemList()

    chromeConfig.setPageLayoutType('FOCUS')
    const focusModeExitEventId = 'ExitFocusView'

    const sendInvitesButton: AACChromeAPI.BUTTON = new AACChromeAPI.Button()

    const sendInvitesButtonId = 'sendInvites'

    sendInvitesButton.setId(sendInvitesButtonId)
    sendInvitesButton.setLabel(t(i18nKeyList.BULK_INVITE_USERS_SEND_INVITES_LABEL))
    sendInvitesButton.setButtonType(AACChromeAPI.ButtonType.PRIMARY)
    sendInvitesButton.setState(AACChromeAPI.ActionState.ENABLED)
    const sendInvitesButtonClickFn = (): void => props.confirmAction()
    AACChromeAPI.getActionEventTarget().addEventListener(sendInvitesButtonId, sendInvitesButtonClickFn)

    const cancelLink = new AACChromeAPI.Button()
    const cancelLinkId = 'cancel'
    cancelLink.setId(cancelLinkId)
    cancelLink.setLabel(t(i18nKeyList.BULK_INVITE_USERS_CANCEL))
    cancelLink.setButtonType(AACChromeAPI.ButtonType.LINK)

    const cancelLinkFn = (): void => {
      window.location.href = getUserManagementURL(partnerId, stageDiveConfig.hostname)
    }
    AACChromeAPI.getActionEventTarget().addEventListener(cancelLinkId, cancelLinkFn)
    AACChromeAPI.getCommonEventTarget().addEventListener(focusModeExitEventId, cancelLinkFn)

    actionList.addItem(cancelLink)
    actionList.addItem(sendInvitesButton)

    objectInfo.setActions(actionList)

    pageHeader.setObjectInfo(objectInfo)
    pageHeader.setPageName(t(i18nKeyList.BULK_INVITE_USERS_PAGE_TITLE))
    chromeConfig.setPageHeader(pageHeader)
    AACChromeAPI.setChromeConfiguration(chromeConfig)
    return () => {
      AACChromeAPI.getActionEventTarget().removeEventListener(sendInvitesButtonId, sendInvitesButtonClickFn)
      AACChromeAPI.getActionEventTarget().removeEventListener(cancelLinkId, cancelLinkFn)
      AACChromeAPI.getCommonEventTarget().removeEventListener(focusModeExitEventId, cancelLinkFn)
    }
  }, [t])

  return (
    <MainContainer>
      <ContentContainer>
        <UsersInvitePreviewAndExecutionCard alertType={props.alertType} invitations={props.invitations}></UsersInvitePreviewAndExecutionCard>
      </ContentContainer>
    </MainContainer>
  )
}
